import React, { useEffect, useState } from 'react';
import { Button, Form, Input, DatePicker, Row, Col, message, Select } from 'antd';
import moment from 'moment';
import { gmrfidCode } from '../../utils';
import {AreaApi} from "gmrfid-service-user-api-client"
const { Option } = Select;

const Query = ({ setFields, setMode, setShowDrawer }) => {
  const [form] = Form.useForm();
  const [provinceCodeData, setProvinceCodeData] = useState([]); // 省
  const [cityCodeData, setCityCodeData] = useState([]); // 城市
  const [areaCodeData, setAreaCodeData] = useState([]); // 区、县
  const [streetCodeData, setStreetCodeData] = useState([]); // 街道
  const [communityData, setCommunityData] = useState([]); // 社区
  const [code, setCode] = useState(null);
  const [provinceCode, setProvinceCode] = useState(null);
  const [cityCode, setCityCode] = useState(null);
  const [areaCode, setAreaCode] = useState(null);
  const [streetCode, setStreetCode] = useState(null);
  const [communityCode, setCommunityCode] = useState(null);
  const [province, setProvince] = useState(null);
  const [city, setCity] = useState(null);
  const [area, setArea] = useState(null);
  const [street, setStreet] = useState(null);
  const [community, setCommunity] = useState(null);
  const [PCode, setPCode] = useState(null);

  /* 省、市、区县、街道、社区 */
  useEffect(() => {
    AreaApi.simpleList({
      param: {
        PCode,
      },
    }).then((res: any) => {
      if (res.data) {
        switch (code) {
          case 'CS':
            setCityCodeData(res.data);
            setAreaCodeData([]);
            setStreetCodeData([]);
            setCommunityData([]);
            break;
          case 'QX':
            setAreaCodeData(res.data);
            setStreetCodeData([]);
            setCommunityData([]);
            break;
          case 'JD':
            setStreetCodeData(res.data);
            setCommunityData([]);
            break;
          case 'SQ':
            setCommunityData(res.data);
            break;
          default:
            setProvinceCodeData(res.data);
            setCityCodeData([]);
            setAreaCodeData([]);
            setStreetCodeData([]);
            setCommunityData([]);
            break;
        }
      }
    });
  }, [PCode, code]);

  const onFinish = (values) => {
    const s = moment(values?.start?._d).valueOf();
    const e = moment(values?.end?._d).valueOf();
    if (s > e) {
      message.warning('结束日期不能小于开始日期');
    } else {
      setFields({
        ...values,
        start: values?.start && `${values?.start?.format('YYYY-MM-DD')} 00:00:00.000`,
        end: values?.end && `${values?.end?.format('YYYY-MM-DD')} 23:59:59.999`,
      });
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <div className="query-form">
      <Form className="form" name="basic" form={form} onFinish={onFinish} onFinishFailed={onFinishFailed}>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item label="关键词" name="name">
              <Input placeholder="请输入项目名称搜索" allowClear />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="认证状态" name="verifyState">
              <Select placeholder="请选择" allowClear>
                <Option value={'NOT_VERIFIED'}>未认证</Option>
                <Option value={'VERIFIED'}>已认证</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8} />
          <Col span={24}>
            <Form.Item label="所在地" className="star address">
              <Input.Group compact className="address_group">
                <Form.Item name="provinceCode" noStyle>
                  <Select
                    style={{ width: '20%' }}
                    placeholder="请选择省份"
                    onChange={(v, e) => {
                      setCode('CS');
                      setProvinceCode(v);
                      setProvince(e.name);
                      setPCode(v);
                      form.setFieldsValue({
                        cityCode: '',
                        areaCode: '',
                        streetCode: '',
                        communityCode: '',
                      });
                    }}
                  >
                    {provinceCodeData.map((item, i) => (
                      <Option key={i} value={item.code} name={item.name}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name="cityCode" noStyle>
                  <Select
                    style={{ width: '20%' }}
                    placeholder="请选择城市"
                    onChange={(v, e) => {
                      setCode('QX');
                      setCityCode(v);
                      setCity(e.name);
                      setPCode(v);
                      form.setFieldsValue({
                        areaCode: '',
                        streetCode: '',
                        communityCode: '',
                      });
                    }}
                  >
                    {cityCodeData.map((item, i) => (
                      <Option key={i} value={item.code} name={item.name}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name="areaCode" noStyle>
                  <Select
                    style={{ width: '20%' }}
                    placeholder="请选择区、县"
                    onChange={(v, e) => {
                      setCode('JD');
                      setAreaCode(v);
                      setArea(e.name);
                      setPCode(v);
                      form.setFieldsValue({
                        streetCode: '',
                        communityCode: '',
                      });
                    }}
                  >
                    {areaCodeData.map((item, i) => (
                      <Option key={i} value={item.code} name={item.name}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name="streetCode" noStyle>
                  <Select
                    style={{ width: '20%' }}
                    placeholder="请选择街道"
                    onChange={(v, e) => {
                      setCode('SQ');
                      setStreetCode(v);
                      setStreet(e.name);
                      setPCode(v);
                      form.setFieldsValue({
                        communityCode: '',
                      });
                    }}
                  >
                    {streetCodeData.map((item, i) => (
                      <Option key={i} value={item.code} name={item.name}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name="communityCode" noStyle>
                  <Select
                    placeholder="请选择社区"
                    style={{ width: '20%' }}
                    onChange={(v, e) => {
                      setCommunityCode(v);
                      setCommunity(e.name);
                    }}
                  >
                    {communityData.map((item, i) => (
                      <Option key={i} value={item.code} name={item.name}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Input.Group>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="创建日期">
              <Form.Item style={{ display: 'inline-block' }} name="start">
                <DatePicker size="large" allowClear />
              </Form.Item>
              <span
                style={{
                  display: 'inline-block',
                  width: '24px',
                  lineHeight: '44px',
                  textAlign: 'center',
                }}
              >
                -
              </span>
              <Form.Item style={{ display: 'inline-block' }} name="end">
                <DatePicker size="large" />
              </Form.Item>
            </Form.Item>
          </Col>
          <Col span={8} />
          <Col span={8}>
            <div className="header-handle">
              <Button
                className="but"
                onClick={() => {
                  form.submit();
                }}
              >
                搜索
              </Button>
              <Button
                className="but"
                onClick={() => {
                  setPCode(null);
                  setCode(null);
                  form.resetFields();
                  setFields({});
                }}
              >
                重置
              </Button>
              {/* <Button
                className="but"
                onClick={() => {
                  setMode('multiple');
                  setShowDrawer(true);
                }}
              >
                批量配置
              </Button> */}
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Query;
